export default function formatDateTime(isoString) {
    // Create a Date object from the ISO string
    const date = new Date(isoString);

    // Convert to local date-time format
    return date.toLocaleString();
}

